<template>
  <div>
    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <!-- Print Only -->
        <HeaderPrint />
        <!-- / Print Only -->
      </div>

      <!-- end/ PRINT ONLY -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="data"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :items-per-page="-1"
          hide-default-footer
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.sales_bets="{ item }">
            <span :class="getColor(item.sales_bets)">{{
              item.sales_bets
            }}</span>
          </template>
          <template v-slot:item.cancellations="{ item }">
            <span :class="getColor(item.cancellations)">{{
              item.cancellations
            }}</span>
          </template>
          <template v-slot:item.commission_bets="{ item }">
            <span :class="getColor(item.commission_bets)">{{
              item.commission_bets
            }}</span>
          </template>
          <template v-slot:item.sales_credits="{ item }">
            <span :class="getColor(item.sales_credits)">{{
              item.sales_credits
            }}</span>
          </template>
          <template v-slot:item.commission_credits="{ item }">
            <span :class="getColor(item.commission_credits)">{{
              item.commission_credits
            }}</span>
          </template>
          <template v-slot:item.comission_local="{ item }">
            <span :class="getColor(item.comission_local)">{{
              item.comission_local
            }}</span>
          </template>
          <template v-slot:item.prizes_paid="{ item }">
            <span :class="getColor(item.prizes_paid)">{{
              item.prizes_paid
            }}</span>
          </template>
          <template v-slot:item.gross_profit="{ item }">
            <span :class="getColor(item.gross_profit)">{{
              item.gross_profit
            }}</span>
          </template>
          <template v-slot:item.comission_regional="{ item }">
            <span :class="getColor(item.comission_regional)">{{
              item.comission_regional
            }}</span>
          </template>
          <template v-slot:item.liquid_profit="{ item }">
            <span :class="getColor(item.liquid_profit)">{{
              item.liquid_profit
            }}</span>
          </template>

          <!-- <template v-slot:item.comission_regional="{ item }">            
            {{
              (item.gross_profit * (item.comission_regional / 100)).toFixed(2)
            }}
            {{
              someComissionRegional(
                item.gross_profit * (item.comission_regional / 100)
              )
            }}
          </template> -->

          <!-- <template v-slot:item.netProfit="{ item }">
            
            {{
              (
                item.gross_profit -
                item.gross_profit * (item.comission_regional / 100)
              ).toFixed(2)
            }}
            {{
              someGrossLiquid(
                item.gross_profit -
                  item.gross_profit * (item.comission_regional / 100)
              )
            }}
          </template> -->

          <template v-slot:item.name_agent="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'regionalManager/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'regionalManager/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account</v-icon>
              {{ item.name_local }}
            </a>
          </template>
          <template v-slot:item.comission_local="{ item }">
            <div>
              <v-chip
                x-small
                :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : ''"
              >
                {{ typeCommissionText(item.type_comission) }}
              </v-chip>
            </div>
            <span class="caption" :class="getColor(item.comission_local)">{{
              item.comission_local
            }}</span>
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-financial-sales-report-collectors",
  components: {
    HeaderPrint,
  },
  data: () => ({
    breakpoint: "xs",
    data: [],
    search: "",
    some: {},
    somaGrossLiquid: 0,
    somaComissionRegional: 0,

    regionalData: {},

    // Resume
    resume: {},
    resumePrint: "",
    keysResume: [],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_route() {
      return this.$store.state.filters.autocompleteRoutes.id;
    },
    // id_agent() {
    //   return this.$store.state.filters.autocompleteAgents.id;
    // },
    typeLive() {
      return this.$store.state.filters.groupTypeLive.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("routeName"), value: "name_route" },
        { text: this.$t("headersAgentName"), value: "name_agent" },
        { text: this.$t("qtdBets"), value: "count_bets", align: " caption" },
        { text: this.$t("soldBets"), value: "sales_bets" },
        { text: this.$t("canceledBets"), value: "cancellations" },
        { text: this.$t("agentCommission"), value: "commission_bets" },
        {
          text: this.$t("qtdSalesCredit"),
          value: "count_credits",
          align: " caption",
        },
        { text: this.$t("creditSales"), value: "sales_credits" },
        { text: this.$t("agentCreditCommission"), value: "commission_credits" },
        { text: this.$t("prizeValue"), value: "prizes_paid" },
        { text: this.$t("localManagerCommission"), value: "comission_local" },
        { text: this.$t("grossProfit"), value: "gross_profit" },
        {
          text: this.$t("regionalManagerCommission"),
          value: "comission_regional",
        },
        { text: this.$t("netProfit"), value: "liquid_profit" },
      ];
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getSalesReportRoute();
    },
  },
  methods: {
    reset() {
      this.search = "";
      this.data = [];
    },

    async getSalesReportRoute() {
      this.reset();
      const body = {
        ...this.rangeDate,
        id_route: this.id_route,
        id_agent: "",
        tipo: this.typeLive,
        export: this.exportDoc,
      };

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/regionalManager/financial/salesReportRoute",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/regionalManager/financial/salesReportRoute",
          body
        );
      }

      if (response.length == 0) return;
      this.data = response.dados;
      this.regionalData = new Object();

      this.data.forEach((item) => {
        if (item.type_comission == "ngr") {
          item.comission_local = Number(item.comission_ngr_local * -1).toFixed(
            2
          );
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = (Number(item.comission_local) * -1).toFixed(2);
        }

        //  Calculando Comissão Regional
        item.comission_regional = (
          Number(item.gross_profit) *
          (Number(item.comission_regional) / 100)
        ).toFixed(2);
        // Calculando Lucro Líquido
        item.liquid_profit = (
          Number(item.gross_profit) - Number(item.comission_regional)
        ).toFixed(2);
        // Cria o Objeto com a chave do ID local onde será somado os valores

        this.regionalData[item.id_local] = {
          agents: [],
          local: {
            count_bets: [],
            count_credits: [],
            sales_bets: [],
            cancellations: [],
            commission_bets: [],
            sales_credits: [],
            commission_credits: [],
            comission_local: [],
            prizes_paid: [],
            gross_profit: [],
            comission_regional: [],
            liquid_profit: [],
            type_comission: "",
          },
        };
      });
      const reducer = (accumulator, currentValue) =>
        (Number(accumulator) + Number(currentValue)).toFixed(2);

      this.data.map((item) => {
        for (var local in this.regionalData) {
          if (item.id_local == local) {
            this.regionalData[local].local.type_comission = item.type_comission;
            this.regionalData[local].agents.push(item);
            this.regionalData[local].local.sales_bets.push(item.sales_bets);
            this.regionalData[local].local.count_bets.push(item.count_bets);
            this.regionalData[local].local.count_credits.push(
              item.count_credits
            );
            this.regionalData[local].local.cancellations.push(
              item.cancellations
            );
            this.regionalData[local].local.commission_bets.push(
              item.commission_bets
            );
            this.regionalData[local].local.sales_credits.push(
              item.sales_credits
            );
            this.regionalData[local].local.commission_credits.push(
              item.commission_credits
            );
            this.regionalData[local].local.comission_local.push(
              item.comission_local
            );
            this.regionalData[local].local.prizes_paid.push(item.prizes_paid);
            this.regionalData[local].local.gross_profit.push(item.gross_profit);
            this.regionalData[local].local.comission_regional.push(
              item.comission_regional
            );
            this.regionalData[local].local.liquid_profit.push(
              item.liquid_profit
            );
          }
        }
      });

      for (var local in this.regionalData) {
        this.regionalData[local].local.sales_bets = this.regionalData[
          local
        ].local.sales_bets.reduce(reducer);
        this.regionalData[local].local.count_bets = this.regionalData[
          local
        ].local.count_bets.reduce(reducer);
        this.regionalData[local].local.count_credits = this.regionalData[
          local
        ].local.count_credits.reduce(reducer);
        this.regionalData[local].local.cancellations = this.regionalData[
          local
        ].local.cancellations.reduce(reducer);
        this.regionalData[local].local.commission_bets = this.regionalData[
          local
        ].local.commission_bets.reduce(reducer);
        this.regionalData[local].local.sales_credits = this.regionalData[
          local
        ].local.sales_credits.reduce(reducer);
        this.regionalData[local].local.commission_credits = this.regionalData[
          local
        ].local.commission_credits.reduce(reducer);
        this.regionalData[local].local.comission_local = this.regionalData[
          local
        ].local.comission_local.reduce(reducer);
        this.regionalData[local].local.prizes_paid = this.regionalData[
          local
        ].local.prizes_paid.reduce(reducer);
        this.regionalData[local].local.gross_profit = this.regionalData[
          local
        ].local.gross_profit.reduce(reducer);
        this.regionalData[local].local.comission_regional = this.regionalData[
          local
        ].local.comission_regional.reduce(reducer);
        this.regionalData[local].local.liquid_profit = this.regionalData[
          local
        ].local.liquid_profit.reduce(reducer);

        // Caso o total da comissão do local seja superior a 0 no caso do NGR o valor da comissão é zerado
        if (
          this.regionalData[local].local.comission_local > 0 &&
          this.regionalData[local].local.type_comission == "ngr"
        ) {
          this.regionalData[local].local.gross_profit = (
            this.regionalData[local].local.gross_profit -
            Number(this.regionalData[local].local.comission_local)
          ).toFixed(2);
          // Calculando Lucro Líquido
          this.regionalData[local].local.liquid_profit = (
            Number(this.regionalData[local].local.gross_profit) -
            Number(this.regionalData[local].local.comission_regional)
          ).toFixed(2);
        }
      }
      this.buildResume(this.regionalData);
    },

    buildResume(data) {
      let locals = [];
      for (var local in data) {
        data[local].local.qtdAgents = data[local].agents.length;
        // Enviando o valor zerado caso a comissão do local seja positiva
        if (
          data[local].local.comission_local > 0 &&
          data[local].local.type_comission == "ngr"
        ) {
          data[local].local.comission_local = 0;
        }

        locals.push(data[local].local);
      }

      // console.log(locals);

      const sum = (key) => {
        return locals
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      let resume = {
        sales_bets: {},
        cancellations: {},
        commission_bets: {},
        sales_credits: {},
        commission_credits: {},
        comission_local: {},
        prizes_paid: {},
        gross_profit: {},
        comission_regional: {},
        liquid_profit: {},
      };
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
        if (key == "comission_local" && resume[key].value > 0) {
          resume[key].value = `${total}`;
          resume[key].classColor = "grey--text";
        }
      });

      const complement = {
        qtdAgents: { value: Number(sum("qtdAgents")) },
        count_credits: { value: Number(sum("count_credits")) },
        count_bets: { value: Number(sum("count_bets")) },
      };

      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);
      this.resumeExcelCopy();
    },

    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `${this.resume.qtdAgents.value
        .toString()
        .replace(".", ",")}
        ${this.resume.count_credits.value.toString().replace(".", ",")}
        ${this.resume.count_bets.value.toString().replace(".", ",")}
        ${this.resume.sales_bets.value.toString().replace(".", ",")}
        ${this.resume.cancellations.value.toString().replace(".", ",")}
        ${this.resume.commission_bets.value.toString().replace(".", ",")}
        ${this.resume.sales_credits.value.toString().replace(".", ",")}
        ${this.resume.commission_credits.value.toString().replace(".", ",")}
        ${this.resume.comission_local.value.toString().replace(".", ",")}
        ${this.resume.prizes_paid.value.toString().replace(".", ",")}
        ${this.resume.gross_profit.value.toString().replace(".", ",")}
        ${this.resume.comission_regional.value.toString().replace(".", ",")}
        ${this.resume.liquid_profit.value.toString().replace(".", ",")}`;
    },

    TranslateKey: function(key) {
      const myKeysTranslated = {
        qtdAgents: this.$t("qtyAgents"),
        comission_regional: this.$t("coRegionalManager"),
        count_bets: this.$t("qtyBet"),
        sales_bets: this.$t("bets"),
        cancellations: this.$t("cancelledBets"),
        commission_bets: this.$t("coAgentBet"),
        count_credits: this.$t("qtyCredits"),
        sales_credits: this.$t("credits"),
        commission_credits: this.$t("coAgentCreditSales"),
        comission_local: this.$t("coGerLocal"),
        prizes_paid: this.$t("awards"),
        liquid_profit: this.$t("netProfit"),
        gross_profit: this.$t("grossProfit"),
      };

      return myKeysTranslated[key] || null;
    },
    infoKey: function(key) {
      const info = {
        name_agent: this.$t("agentName"),
        qtdAgents: this.$t("numbersOfAgents"),
        comission_regional: this.$t("commissionRegionalOnGrossProfit"),
        count_bets: this.$t("amountBetsSold"),
        sales_bets: this.$t("bettingSalesValue"),
        cancellations: this.$t("reverseOfCanceledBets"),
        commission_bets: this.$t("agentsCommissiononBettingSales"),
        count_credits: this.$t("amountOFCreditsSold"),
        sales_credits: this.$t("creditSalesAmount"),
        commission_credits: this.$t("agentCommissionInfoKey"),
        prizes_paid: this.$t("awardValue"),
        comission_local: this.$t("localManagerCommissionInfoKey"),
        liquid_profit: this.$t("netProfitResume"),
        gross_profit: this.$t("groosProfitResume"),
      };

      return info[key] || null;
    },
    getColor(value) {
      // Return Agente, Qtd Apostas, Qtd Crétido;
      // if (index == 0 || index == 1 || index == 5) return;
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    typeCommissionText(type_comission) {
      const commissionLocal = {
        ngr: "NGR",
        bruto: this.$t("gross"),
      };
      return commissionLocal[type_comission];
    },
    cleanPositiveValueUI(value) {
      if (value > 0) {
        return { value: `0  (${value})`, classColor: "grey--text darken-4" };
      } else {
        return { value: value, classColor: this.getColor(value) };
      }
    },
  },
};
</script>
